import { ROWS_PER_PAGE_OPTIONS } from './PaginationWithoutButtons.constants'
import { DEFAULT_NAMESPACE } from 'config/i18n'
import { useTranslation } from 'react-i18next'
import { TablePaginationProps } from './PaginationWithoutButtons.types'

export const usePagination = ({
  pageSize,
  page,
  totalRowsCount,
  sizes,
}: TablePaginationProps) => {
  const { t } = useTranslation(DEFAULT_NAMESPACE)

  const options = (sizes || ROWS_PER_PAGE_OPTIONS).map(item => ({
    title: item,
    value: item,
  }))

  const paginationInfoString = t('of', {
    min: `${(page - 1) * pageSize + 1}`,
    max: `${
      page * pageSize > totalRowsCount ? totalRowsCount : page * pageSize
    } `,
    all: `${totalRowsCount}`,
  })

  return {
    pageSize,
    paginationInfoString,
    options,
  }
}
